import { ArrowLeft, ArrowUpRight, Download } from 'lucide-react';
import { Link } from 'react-router-dom';
import { Seo } from '../Seo';
import { JourneyShowcase } from './JourneyShowcase';

/**
 * FilmJourney — now a thin shell around JourneyShowcase.
 *
 * The old scroll-driven film (115svh-per-scene sticky scroll travel) was the
 * drop-off center: buyers had to survive the whole scroll to reach the proof
 * and booking CTA. The showcase keeps narration chapters (capabilities + human
 * checkpoints) on the left and the sticky MacBook product surface on the right,
 * click-driven, so nothing below the fold is gated behind scroll endurance.
 */
export const FilmJourney = ({ film, customer = false, onJoin }) => {
  return <div className={`cinematic-journey cinematic-${film.id}`} data-testid={`${film.id}-destination-page`}>
    <Seo title={`${film.label} — Acoord Ahi`} description={film.scenes[0].body} path={film.path} />
    <header className="film-header journey-header" data-testid={`${film.id}-film-header`}>
      <Link to={customer ? '/demo' : '/investor?intent=investor'} data-testid={`${film.id}-back-link`}><ArrowLeft size={14} /> Change lens</Link>
      <div><span>{film.label}</span>{film.context && <b data-testid={`${film.id}-context-label`}>{film.context.toUpperCase()}</b>}</div>
    </header>
    <JourneyShowcase film={film} />
    <section className="film-proof" data-testid={`${film.id}-proof-boundary`}><div><span>BUILT</span><p>{film.proof.built}</p></div><div><span>ARCHITECTURE</span><p>{film.proof.architecture}</p></div>{customer && <div><span>MODELED</span><p>{film.proof.modeled}</p></div>}</section>
    <section className="film-close" data-testid={`${film.id}-close-section`}><p>NEXT / HUMAN CONVERSATION</p><h2>{film.close}</h2><div><a href={process.env.REACT_APP_BOOKING_URL} target="_blank" rel="noreferrer" data-testid={`${film.id}-book-link`}>Book a working session <ArrowUpRight size={15} /></a><button type="button" onClick={onJoin} data-testid={`${film.id}-waitlist-button`}><Download size={14} /> Join the desktop waitlist</button></div></section>
  </div>;
};
